import React from "react";
import { Route } from "react-router-dom";
import OffersArs from "../containers/PharmacyLayout/offers-ars-view";

const HomePageP = React.lazy(() => import("../containers/PharmacyLayout/Home"));
const PharmacyLayout = React.lazy(() => import("../containers/PharmacyLayout"));
const ElectronicRecipes = React.lazy(
  () => import("../containers/PharmacyLayout/electronic-recipes-view/Electronic-recipes"),
);
const LatestAuthorizations = React.lazy(
  () => import("../containers/PharmacyLayout/lastest-authorization-view/Latest-Authorizations"),
);
const Collaborators = React.lazy(
  () => import("../containers/PharmacyLayout/collaborator-view/Collaborators"),
);
const SendAudit = React.lazy(
  () => import("../containers/PharmacyLayout/send-audit-view/"),
);
const HistoricalTransactions = React.lazy(
  () => import("../containers/PharmacyLayout/historical-transaction-view/HistoricalTransactions"),
);

export default function PharmacyRoutes({ profile, user, pharmacy }) {
  return (
    <>
      {/* ************************************Layout Farmacia********************************* */}
      {/* HomePage */}
      <Route exact path="/">
        <HomePageP profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Autorizaciones Layout*/}
      <Route exact path="/authorizations">
        <PharmacyLayout profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Recetas Electronicas Layout*/}
      <Route exact path="/electronic-recipes">
        <ElectronicRecipes profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Ultimas Autorizaciones Layout*/}
      <Route exact path="/lastest-authorizations">
        <LatestAuthorizations profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Colaboradores Layout*/}
      <Route exact path="/collaborators">
        <Collaborators profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Envio a Auditoria Layout*/}
      <Route exact path="/send-audit">
        <SendAudit profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Histórico de Transacciones Layout*/}
      <Route exact path="/historical-transactions">
        <HistoricalTransactions profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Ofertas Por ARS Layout*/}
      <Route exact path="/offers-ars">
        <OffersArs profile={profile} user={user} pharmacy={pharmacy} />
      </Route>
    </>
  );
}
